import { render } from "./Spiner.vue?vue&type=template&id=345f0946&bindings={}"
import script from "./Spiner.vue?vue&type=script&lang=js"
export * from "./Spiner.vue?vue&type=script&lang=js"
script.render = render

export default script